module.exports = __webpack_public_path__ + "img/related-intro-small.fbf6264b.png";